/*
 * File: conditional-wrapper.ts
 * File Created: 2024-01-05 09:49:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-14 09:53:22
 * Modified By: Val Liu
 * -----
 */

import { CreateElement } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";

/// if the "condition" is true, wrap the "wrapper" at outer of the component.
@Component
export default class ConditionalWrapper extends Vue {
    @Prop({ type: Boolean, required: true })
    condition!: boolean;

    @Prop({ type: String, required: true })
    wrapper!: string;

    render(h: CreateElement) {
        if (this.condition && this.wrapper) {
            return h(
                this.wrapper,
                {
                    props: this.$props,
                    attrs: this.$attrs,
                    on: this.$listeners,
                },
                this.$slots.default,
            );
        } else {
            return this.$slots.default;
        }
    }
}
